// ✅ BetAmountPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar2 from "../components/navbar/Navbar2";
import AOS from "aos";
import "aos/dist/aos.css";
import { socket } from "../api";
import LoadingPage from "./LoadingPage";
import DigitalTimer from "./DigitalTimer";
import HomePageFooter from "../components/navbar/HomePageFooter";

const BetAmountPage = () => {
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 500, easing: "ease-in-sine" });

    // 🔁 Always request full room list on mount
    socket.emit("get-rooms");

    // ✅ FULL SNAPSHOT (authoritative)
    socket.on("room-list", (list) => {
      setRooms((prev) => {
        // First load → sort and set
        if (prev.length === 0) {
          return [...list].sort((a, b) => Number(a.id) - Number(b.id));
        }

        // After first load → MERGE only (no replace, no sort)
        return prev.map((room) => {
          const fresh = list.find((r) => r.roomId === room.roomId);
          return fresh ? { ...room, ...fresh } : room;
        });
      });

      setLoading(false);
    });

    // ✅ SINGLE ROOM UPDATE (authoritative)
    socket.on("room-update", (updatedRoom) => {
      setRooms((prev) =>
        prev.map((room) =>
          room.roomId === updatedRoom.roomId
            ? { ...room, ...updatedRoom }
            : room,
        ),
      );
    });

    // 🔄 Safety sync every second (prevents stale UI)
    const syncInterval = setInterval(() => {
      socket.emit("get-rooms");
    }, 1000);

    return () => {
      socket.off("room-list");
      socket.off("room-update");
      clearInterval(syncInterval);
    };
  }, []);

  const handleJoinClick = (room) => {
    if (room.status === "playing") {
      navigate("/play", {
        state: {
          roomInfo: room,
        },
      });
    } else {
      navigate(
        `/select-cards?room=${room.roomId}&stake=${room.amount}&win=${room.winAmount}`,
      );
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="min-h-screen bg-primary text-white">
      <div className="fixed left-0 right-0 top-0 z-50 bg-gradient-to-l from-cyan-900 via-cyan-800 to-cyan-900">
        <Navbar2 />
      </div>

      <div className="text-center pt-20">
        <h1 className="text-2xl font-semibold font-serif text-yellow-400 tracking-wide">
          Please Choose Your Stake
        </h1>
      </div>

      <div className="mt-10 flex justify-center">
        {/* ✅ Outer container glow */}
        <div className="w-full max-w-4xl rounded-lg overflow-hidden shadow-xl px-1">
          {/* ✅ Header as card */}
          <div
            className="
grid grid-cols-4
text-center
items-center
py-4
mb-3

rounded-xl

bg-[#1F2937]

border border-yellow-500/15

shadow-[0_12px_30px_rgba(0,0,0,.45)]

hover:bg-[#243244]

hover:border-yellow-400/40

hover:shadow-[0_0_25px_rgba(250,204,21,.18)]

hover:scale-[1.02]

transition-all
duration-300

font-serif
"
          >
            <div>Stake</div>
            <div>Active</div>
            <div>Win</div>
            <div>Join</div>
          </div>

          {rooms.map((room) => {
            return (
              <div
                key={room.roomId}
                className="
grid grid-cols-4
text-center
items-center
py-1
my-3
rounded-xl

bg-gradient-to-r
from-[#1E293B]
to-[#273549]

border border-slate-600

shadow-[0_8px_20px_rgba(0,0,0,0.45)]

hover:from-[#26364A]
hover:to-[#334155]

hover:border-yellow-500/40

hover:shadow-[0_10px_25px_rgba(250,204,21,.18)]

hover:scale-[1.02]

transition-all
duration-300

font-serif
"
              >
                <div className="text-slate-100 font-semibold">
                  {room.amount} Birr
                </div>

                <div className="text-sm">
                  {room.status === "counting" ? (
                    <DigitalTimer seconds={room.countdown} />
                  ) : room.status === "playing" ? (
                    <span className="font-semibold text-emerald-400">
                      Playing
                    </span>
                  ) : (
                    <span className="text-slate-400">Waiting</span>
                  )}
                </div>

                <div className="font-bold text-yellow-400">
                  {room.winAmount ? `${room.winAmount} Birr` : "—"}
                </div>

                <div>
                  <button
                    onClick={() => handleJoinClick(room)}
                    className={`px-5 py-2 rounded-lg font-semibold transition-all duration-300 ${
                      room.status === "playing"
                        ? "bg-gradient-to-r from-[#334155] to-[#475569] text-white border border-slate-500 hover:from-[#475569] hover:to-[#64748B]"
                        : "bg-gradient-to-r from-[#FACC15] to-[#EAB308] text-[#111827] hover:from-[#FDE047] hover:to-[#FACC15] shadow-[0_6px_15px_rgba(250,204,21,.25)] hover:shadow-[0_10px_25px_rgba(250,204,21,.4)] hover:scale-105"
                    }`}
                  >
                    {room.status === "playing" ? "Open »" : "» Join"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <HomePageFooter />
    </div>
  );
};

export default BetAmountPage;
